
import useAxiosPrivate  from './useAxiosPrivate'

const useRequests = () => {
    const http = useAxiosPrivate();

    const get = async(pathname)=>{
        return await http.get(pathname);
    }

    const post = async(pathname, data)=>{
        return await http.post(pathname, data);
    }

    const update = async(pathname, data)=>{
      return await http.patch(pathname, data);
  }


    const remove = async(pathname)=>{
        return await http.delete(pathname);
    }

    const upload = (pathname, formData, onUploadProgress) => {
 
        return http.post(pathname, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress,
        });
      };

  return {get, post,update,upload, remove}
}

export default useRequests;